import _axios from '@/plugins/axios';
import { UsersError } from '@/lib/Errors';

export default {
	async getConsumables () {
		const response = await _axios.get('inventory/consumable');
		if (response.data.resFlag) {
			return response.data.data || [];
		} else if (response.data.msg === 'No inventory consumables found.') {
			return [];
		}
		throw new UsersError('Error getting consumable!');
	},
	async getConsumableById (id) {
		const response = await _axios.get(`inventory/consumable/${id}`);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error getting consumable model!');
	},
async addConsumable (body) {
		const response = await _axios.post('inventory/consumable', body);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error adding consumable model!');
	},
	async editConsumable (body) {
		const response = await _axios.put(`inventory/consumable/${body.id}`, body);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('Error editing consumable model!');
	},
	async deleteConsumable (id) {
		const response = await _axios.delete(`inventory/consumable/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error deleting consumable model!');
	},

	async getInventoryConsumableStatuses () {
		const response = await _axios.get('inventory/consumable/getinventoryconsumablestatuses');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new UsersError('Error deleting consumable statuses!');
		},

};
